<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row v-if="isShowDeadlineAlert">
          <v-col>
            <div v-for="(item, index) in alertList" :key="index">
              <DeadlineAlert
                :item="item"
                @onClickdAlertRead="onClickdAlertRead"
              />
            </div>
          </v-col>
        </v-row>
        <v-row v-if="userInfo.existsNewExternalOrder">
          <v-col>
            <div>
              <NewOrderAlert @onClickdAlertRead="closeNewOrderAlert" />
            </div>
          </v-col>
        </v-row>
        <v-row v-if="!authority.isOutsideStaff">
          <v-col>
            <AggregateInformation />
          </v-col>
        </v-row>
        <v-spacer class="ma-5" />
        <v-row v-if="!authority.isOutsideStaff">
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">
              {{ $t('common.common_balance-data') }}
            </h2>
          </v-col>
        </v-row>
        <v-row class="row-contents" v-if="!authority.isOutsideStaff">
          <v-col>
            <ChartBalanceOfPayment />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text">
              {{ $t('common.common_recent-order-history') }}
            </h2>
          </v-col>
        </v-row>
        <v-row class="row-contents">
          <v-col>
            <HistoryList
              :summary="orderHistorySummary"
              :historyList="orderHistoryList"
              :headers="orderHistoryHeaders"
              :productListHeaders="orderHistoryProductListHeaders"
              itemKey="orderId"
              :hiddenHeaderOperation="true"
              @rowDialogMethodCommon="rowDialogMethodCommonOrderHistory"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="yCenter">
            <h2 class="dashboard-title primary--text">
              {{ $t('common.common_recent-sales-history') }}
            </h2>
          </v-col>
        </v-row>
        <v-row class="row-contents">
          <v-col>
            <HistoryList
              :summary="saleHistorySummary"
              :historyList="saleHistoryList"
              :headers="saleHistoryHeaders"
              :productListHeaders="saleHistoryProductListHeaders"
              itemKey="saleId"
              :hiddenHeaderOperation="true"
              @rowDialogMethodCommon="rowDialogMethodCommonSaleHistory"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <LoadingDialog
      v-model="orderHistoryDialogs.loading"
      :title="$t('loading.loading_loading-operation')"
      :recItems="orderHistoryDialogs.loading.rowItems"
      :pageInfoData="orderHistoryDialogs.loading.pageInfoData"
      @complete="completeLoading"
    >
      <template #historyList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </LoadingDialog>
    <OrderDetailDialog
      v-model="orderHistoryDialogs.orderDetail"
      :title="$t('order.order_order-details')"
      width="80%"
      :recItems="orderHistoryDialogs.orderDetail.rowItems"
      :pageInfoData="orderHistoryDialogs.orderDetail.pageInfoData"
      @complete="completeOrderDetail"
    >
      <template #loadingHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </OrderDetailDialog>
    <ShipDialog
      v-model="saleHistoryDialogs.ship"
      :title="$t('sale.sale_ship-operate')"
      :recItems="saleHistoryDialogs.ship.rowItems"
      :pageInfoData="saleHistoryDialogs.ship.pageInfoData"
      @complete="completeShip"
      :dialogReload="saleHistoryDialogs.ship.dialogReload"
    >
      <template #historyList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
          @dialogReload="dialogReload('ship')"
        >
        </HistoryList>
      </template>
    </ShipDialog>
    <SalesDetailDialog
      v-model="saleHistoryDialogs.salesDetail"
      :title="$t('common.input_sale-details')"
      width="80%"
      :recItems="saleHistoryDialogs.salesDetail.rowItems"
      :pageInfoData="saleHistoryDialogs.salesDetail.pageInfoData"
    >
      <template #shipHistoryList="{ item }">
        <HistoryList
          isOperation="ture"
          :historyList="item.historyList"
          :headers="item.headers"
          :itemKey="item.tableKey"
          :productListHeaders="item.productListHeaders"
        >
        </HistoryList>
      </template>
    </SalesDetailDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { commonUtil } from '@/util'
import { orderStatusHistory, saleStatusHistory } from '@/config'
import { HistoryList } from '@/components/layouts'
import {
  LoadingDialog,
  OrderDetailDialog,
  ShipDialog,
  SalesDetailDialog
} from '@/components/layouts/Dialogs'

import DeadlineAlert from '@/components/layouts/Dashboard/DeadlineAlert'
import NewOrderAlert from '@/components/layouts/Dashboard/NewOrderAlert'
import AggregateInformation from '@/components/layouts/Dashboard/AggregateInformation'
import ChartBalanceOfPayment from '@/components/layouts/Dashboard/ChartBalanceOfPayment'

import orderHistoryHeaders from '@/views/order/History/headers'
import saleHistoryHeaders from '@/views/sales/History/headers'

export default {
  name: 'Dashboard',
  components: {
    DeadlineAlert,
    NewOrderAlert,
    AggregateInformation,
    ChartBalanceOfPayment,
    HistoryList,
    LoadingDialog,
    OrderDetailDialog,
    ShipDialog,
    SalesDetailDialog
  },
  data: () => {
    return {
      panel1: [0],
      panel2: [0],
      // orderHistory関連
      orderHistorySummary: {},
      orderHistoryList: [],
      orderHistoryHeaders: orderHistoryHeaders.headers,
      orderHistoryProductListHeaders: orderHistoryHeaders.productListHeaders,
      orderHistoryDialogs: {
        loading: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        },
        orderDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      },
      // saleHistory関連
      saleHistorySummary: {},
      saleHistoryList: [],
      saleHistoryHeaders: saleHistoryHeaders.headers,
      saleHistoryProductListHeaders: saleHistoryHeaders.productListHeaders,
      saleHistoryDialogs: {
        ship: {
          dialog: false,
          rowItems: {},
          pageInfoData: {},
          dialogReload: 0
        },
        salesDetail: {
          dialog: false,
          rowItems: {},
          pageInfoData: {}
        }
      }
    }
  },
  async created() {
    await Promise.all([
      this.getProductExpiredDateAlertUnreadsFromApi(),
      this.makeOrderHistoryList(),
      this.makeSalesHistoryList()
    ])
  },
  computed: {
    ...mapGetters('User', [
      'getProductExpiredDateAlertUnreadsFromState',
      'getUserInfoFromState',
      'authority'
    ]),
    ...mapGetters('Order', ['getOrderListFromState']),
    ...mapGetters('Sale', ['getSaleListFromState']),
    alertList() {
      return this.getProductExpiredDateAlertUnreadsFromState
    },
    isShowDeadlineAlert() {
      return this.getProductExpiredDateAlertUnreadsFromState.length > 0
    },
    userInfo() {
      return this.getUserInfoFromState
    }
  },
  methods: {
    ...mapActions('User', [
      'patchProductExpiredDateAlertRead',
      'getProductExpiredDateAlertUnreadsFromApi',
      'setUserInfo'
    ]),
    ...mapActions('Order', ['getOrderListFromApi']),
    ...mapActions('Sale', ['getSaleListFromApi']),
    async onClickdAlertRead(item) {
      await this.patchProductExpiredDateAlertRead({
        id: item.productExpiredDateAlertId
      })
      await this.getProductExpiredDateAlertUnreadsFromApi()
    },
    closeNewOrderAlert() {
      const userInfo = this.userInfo
      userInfo.existsNewExternalOrder = false
      this.setUserInfo(userInfo)
    },
    async makeSalesHistoryList() {
      // FIXME: 発注履歴の生成処理_本来であれば共通化すべきだか時間優先なのでコピペ
      const isObject = (val) => {
        return val && typeof val === 'object'
      }
      const formatObjectRequest = (val) => {
        return isObject(val) ? val.value : val
      }
      const getBeforeCompleteFlgTmp = (rec) => {
        return rec.status == 1 && !rec.compDate
      }
      const getPaymentStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = saleStatusHistory.PAYMENT_STATUS
        switch (status.value) {
          case statusList.BEFORE_PAYMENT: {
            return 1
          }
          case statusList.AFTER_PAYMENT: {
            return 2
          }
          default: {
            return null
          }
        }
      }
      const getShipStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = saleStatusHistory.SHIP_STATUS
        switch (status.value) {
          case statusList.BEFORE_SHIP: {
            return 1
          }
          case statusList.AFTER_SHIP: {
            return 2
          }
          default: {
            return null
          }
        }
      }
      const getSaleStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = saleStatusHistory.COMPLETE_STATUS
        switch (status.value) {
          case statusList.BEFORE_COMPLETE: {
            return 1
          }
          case statusList.AFTER_COMPLETE: {
            return 2
          }
          case statusList.CANCEL: {
            return 3
          }
          default: {
            return null
          }
        }
      }
      const searchDetailInfo = {
        line1: {
          saleDate: { start: '', end: '' },
          completionDate: { start: '', end: '' },
          paymentDay: { start: '', end: '' },
          shipDate: { start: '', end: '' }
        },
        line2: {
          paymentStatus: {},
          shipStatus: {},
          saleStatus: {},
          createUser: {}
        },
        line3: {
          customerNameAndCurrency: {
            customerName: [],
            currency: { label: '', value: null }
          },
          saleInfo: {
            saleNumber: '',
            remittanceNumber: ''
          },
          ecSaleInfo: {
            saleNumber: ''
          },
          productInfo: {
            number: '',
            category: ''
          },
          productName: ''
        }
      }
      const line1 = searchDetailInfo.line1
      const line2 = searchDetailInfo.line2
      const line3 = searchDetailInfo.line3
      // Status
      const paymentStatus = getPaymentStatusSearchValue(line2.paymentStatus)
      const shipStatus = getShipStatusSearchValue(line2.shipStatus)
      const saleStatus = getSaleStatusSearchValue(line2.saleStatus)

      await this.getSaleListFromApi({
        invalidSaleDisplay: 0,
        saleStartDate: commonUtil.nullEmptyFormatNull(line1.saleDate.start),
        saleEndDate: commonUtil.nullEmptyFormatNull(line1.saleDate.end),
        completedStartDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.start
        ),
        completedEndDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.end
        ),
        paymentStartDate: commonUtil.nullEmptyFormatNull(
          line1.paymentDay.start
        ),
        paymentEndDate: commonUtil.nullEmptyFormatNull(line1.paymentDay.end),
        shipStartDate: commonUtil.nullEmptyFormatNull(line1.shipDate.start),
        shipEndDate: commonUtil.nullEmptyFormatNull(line1.shipDate.end),
        salePaymentStatusId: commonUtil.nullEmptyFormatNull(paymentStatus),
        shipStatusId: commonUtil.nullEmptyFormatNull(shipStatus),
        saleStatusId: commonUtil.nullEmptyFormatNull(saleStatus),
        userId: commonUtil.nullEmptyFormatNull(
          formatObjectRequest(line2.createUser)
        ),
        customerIds: commonUtil.nullEmptyFormatNull(
          line3.customerNameAndCurrency.customerName
            .map((customerName) => {
              return customerName.value
            })
            .join(',')
        ),
        currencyId: commonUtil.nullEmptyFormatNull(
          formatObjectRequest(line3.customerNameAndCurrency.currency)
        ),
        searchKey: commonUtil.nullEmptyFormatNull(line3.saleInfo.saleNumber),
        remittanceNumber: commonUtil.nullEmptyFormatNull(
          line3.saleInfo.remittanceNumber
        ),
        exOrderNumber: commonUtil.nullEmptyFormatNull(
          line3.ecSaleInfo.saleNumber
        ),
        productNumber: commonUtil.nullEmptyFormatNull(line3.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line3.productInfo.category
        ),
        productName: commonUtil.nullEmptyFormatNull(line3.productName)
      })

      const getList = this.getSaleListFromState
      const filteredList = getList.filter(
        (item) => !(item.status == 1 && item.compDate)
      )
      const isNoData = !Object.keys(filteredList).length
      const historyList = isNoData
        ? []
        : filteredList
            .sort((a, b) => {
              const keyName = 'saleId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              ele.beforeCompleteFlgTmp = getBeforeCompleteFlgTmp(ele)
              return ele
            })
      // 先頭5件のみにする
      this.saleHistoryList = historyList.slice(0, 5)
    },
    async makeOrderHistoryList() {
      // FIXME: 発注履歴の生成処理_本来であれば共通化すべきだか時間優先なのでコピペ
      const isObject = (val) => {
        return val && typeof val === 'object'
      }
      const getBeforeCompleteFlgTmp = (rec) => {
        return rec.status == 1 && !rec.compDate
      }
      const getWithdrawStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = orderStatusHistory.WITHDRAW_STATUS
        switch (status.value) {
          case statusList.BEFORE_WITHDRAW: {
            return 1
          }
          case statusList.AFTER_WITHDRAW: {
            return 2
          }
          default: {
            return null
          }
        }
      }
      const getLoadingStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = orderStatusHistory.LOADING_STATUS
        switch (status.value) {
          case statusList.BEFORE_LOADING: {
            return 1
          }
          case statusList.AFTER_LOADING: {
            return 2
          }
          default: {
            return null
          }
        }
      }
      const getOrderStatusSearchValue = (status) => {
        if (!isObject(status)) return null
        const statusList = orderStatusHistory.COMPLETE_STATUS
        switch (status.value) {
          case statusList.BEFORE_COMPLETE: {
            return 1
          }
          case statusList.AFTER_COMPLETE: {
            return 2
          }
          case statusList.CANCEL: {
            return 3
          }
          default: {
            return null
          }
        }
      }
      const formatObjectRequest = (val) => {
        return isObject(val) ? val.value : val
      }

      const searchDetailInfo = {
        line1: {
          withdrawDate: { start: '', end: '' },
          orderDate: { start: '', end: '' },
          completionDate: { start: '', end: '' },
          loadingDate: { start: '', end: '' }
        },
        line2: {
          withdrawStatus: {},
          loadingStatus: {},
          orderStatus: {},
          createUser: {}
        },
        line3: {
          supplierNameAndCurrency: {
            supplierName: [],
            currency: { label: '', value: null }
          },
          orderInfo: {
            orderNumber: ''
          },
          productInfo: {
            number: '',
            category: ''
          },
          productName: ''
        }
      }
      const line1 = searchDetailInfo.line1
      const line2 = searchDetailInfo.line2
      const line3 = searchDetailInfo.line3
      // Status
      const withdrawStatus = getWithdrawStatusSearchValue(line2.withdrawStatus)
      const loadingStatus = getLoadingStatusSearchValue(line2.loadingStatus)
      const orderStatus = getOrderStatusSearchValue(line2.orderStatus)

      await this.getOrderListFromApi({
        invalidOrderDisplay: 0,
        orderStartDate: commonUtil.nullEmptyFormatNull(line1.orderDate.start),
        orderEndDate: commonUtil.nullEmptyFormatNull(line1.orderDate.end),
        completedStartDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.start
        ),
        completedEndDate: commonUtil.nullEmptyFormatNull(
          line1.completionDate.end
        ),
        paymentStartDate: commonUtil.nullEmptyFormatNull(
          line1.withdrawDate.start
        ),
        paymentEndDate: commonUtil.nullEmptyFormatNull(line1.withdrawDate.end),
        loadingStartDate: commonUtil.nullEmptyFormatNull(
          line1.loadingDate.start
        ),
        loadingEndDate: commonUtil.nullEmptyFormatNull(line1.loadingDate.end),
        orderPaymentStatusId: commonUtil.nullEmptyFormatNull(withdrawStatus),
        loadingStatusId: commonUtil.nullEmptyFormatNull(loadingStatus),
        orderStatusId: commonUtil.nullEmptyFormatNull(orderStatus),
        userId: commonUtil.nullEmptyFormatNull(
          formatObjectRequest(line2.createUser)
        ),
        supplierIds: commonUtil.nullEmptyFormatNull(
          line3.supplierNameAndCurrency.supplierName
            .map((supplierName) => {
              return supplierName.value
            })
            .join(',')
        ),
        currencyId: commonUtil.nullEmptyFormatNull(
          formatObjectRequest(line3.supplierNameAndCurrency.currency)
        ),
        searchKey: commonUtil.nullEmptyFormatNull(line3.orderInfo.orderNumber),
        productNumber: commonUtil.nullEmptyFormatNull(line3.productInfo.number),
        productCategoryId: commonUtil.nullEmptyFormatNull(
          line3.productInfo.category
        ),
        productName: commonUtil.nullEmptyFormatNull(line3.productName)
      })

      const getList = this.getOrderListFromState
      const filteredList = getList.filter(
        (item) => !(item.status == 1 && item.compDate)
      )
      const isNoData = !Object.keys(filteredList).length
      const historyList = isNoData
        ? []
        : filteredList
            .sort((a, b) => {
              const keyName = 'orderId'
              if (a[keyName] > b[keyName]) return -1
              if (a[keyName] < b[keyName]) return 1
              return 0
            })
            .map((ele, Index) => {
              ele.panelIndex = Index + 1
              ele.beforeCompleteFlgTmp = getBeforeCompleteFlgTmp(ele)
              return ele
            })
      // 未完了の先頭5件のみにする
      this.orderHistoryList = historyList.slice(0, 5)
    },
    async rowDialogMethodCommonOrderHistory(...args) {
      const [dialogName, info] = args
      switch (dialogName) {
        case 'reload': {
          await this.makeOrderHistoryList()
          break
        }
        default:
          this.rowDialogMethodLoadingOrderHistory(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSetOrderHistory(type, rowItems, pageInfoData) {
      const dataInfo = this.orderHistoryDialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodLoadingOrderHistory(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSetOrderHistory(
        type,
        rowItems,
        pageInfoData
      )
    },
    async rowDialogMethodCommonSaleHistory(...args) {
      const [dialogName, info] = args

      switch (dialogName) {
        case 'reload': {
          await this.makeSalesHistoryList()
          break
        }
        default:
          this.rowDialogMethodShipSaleHistory(dialogName, ...info)
      }
    },
    rowDialogMethodCommonDataSetSaleHistory(type, rowItems, pageInfoData) {
      const dataInfo = this.saleHistoryDialogs[type]
      dataInfo.rowItems = rowItems
      dataInfo.pageInfoData = pageInfoData
      dataInfo.dialog = true
    },
    rowDialogMethodShipSaleHistory(type, ...args) {
      const [rowItems, pageInfoData] = args
      this.rowDialogMethodCommonDataSetSaleHistory(type, rowItems, pageInfoData)
    },
    async completeShip() {
      await this.makeSalesHistoryList()
      this.saleHistoryDialogs.ship.dialog = false
    },
    dialogReload(propertyName) {
      this.saleHistoryDialogs[propertyName].dialogReload = this
        .saleHistoryDialogs[propertyName].dialogReload
        ? 0
        : 1
    },
    async completeLoading() {
      await this.makeOrderHistoryList()
      this.orderHistoryDialogs.loading.dialog = false
    },
    async completeOrderDetail() {
      await this.makeOrderHistoryList()
      this.orderHistoryDialogs.orderDetail.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard-title {
  margin-top: 24px;
}

.row-contents {
  margin-top: 0 !important;
}

::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
  .v-expansion-panel-header {
    font-size: 18px;
    font-weight: bold;
  }
  .productInfo .orderHeader {
    padding-left: 0;
  }
}
</style>
